import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/lib/apiClient";

/**
 * Source for the service-first waitlist add-entry form (waitlist README
 * §4.2 "eligible masters" / §4.6): active services and, per service, the
 * masters the MATCHER could ever offer — linked with online booking on and
 * not fired — each with their own effective duration for that service
 * (catalog default or the per-master override). Computed server-side with
 * the same helpers the availability engine uses, so the list and the
 * durations the admin sees are exactly what the matcher will hunt for.
 */

export type WaitlistCatalogStaff = {
  id: number;
  name: string;
  specialization: string;
  avatar_url?: string | null;
  /** effective length of THIS service for THIS master, seconds */
  duration_sec: number;
};

export type WaitlistCatalogService = {
  id: number;
  title: string;
  category_id: number;
  category_title: string;
  /** catalog default length, seconds */
  duration_sec: number;
  staff: WaitlistCatalogStaff[];
};

export type WaitlistCatalog = {
  services: WaitlistCatalogService[];
  categories: { id: number; title: string }[];
};

export const WAITLIST_CATALOG_KEY = ["waitlist", "catalog"];

export function useWaitlistCatalog(enabled = true) {
  return useQuery<WaitlistCatalog>({
    queryKey: WAITLIST_CATALOG_KEY,
    queryFn: async () =>
      (await apiClient.get("/api/v1/company/waitlist/catalog")).data,
    // The form opens rarely; a minute of staleness is fine, but a reopen
    // after editing a staff profile should see the new toggles/durations.
    staleTime: 60_000,
    // never refetch underneath an open form on tab focus — the masters
    // checklist is keyed on the service id and must not be disturbed
    refetchOnWindowFocus: false,
    enabled,
  });
}
